import * as React from 'react';
import styled from 'styled-components';

// Components
import { TextField } from '../../../../../../../../../components/TextField';
import { PlainRenderElementsWrapper } from './PlainRenderInputElement';

// Context
import { RuleEditorContext } from '../../context';

// Enums
import { dtoState } from '../../../../../../../../../common/enums/dtoState';

// Hooks
import { useCriteriaStorePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStorePredicate';
import { useCriteriaStoreUpdatePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStoreUpdatePredicate';
import { useDebouncedStringCallback } from '../../../../../../hooks/useDebouncedStringCallback';

// Types
import { ruleEditorViewPartCommonProps } from '../../types';

const IdentifierContainer = styled.div`
    max-width: 14rem;
`;

export const IdentifierInput = ({ id, plainrender = true, ...props }) => {
    const { setEdited } = React.useContext(RuleEditorContext);
    const part = useCriteriaStorePredicate(id);
    const updatePredicateElement = useCriteriaStoreUpdatePredicate();
    const [rootValue, setRootValue] = useDebouncedStringCallback({
        startVal: part?.defaultIdentifierRoot,
        debounceCallback: (newVal) => {
            setEdited(true);
            updatePredicateElement({
                ...part,
                dtoState: dtoState.Updated,
                defaultIdentifierRoot: newVal
            });
        }
    });
    const [extensionValue, setExtensionValue] = useDebouncedStringCallback({
        startVal: part?.defaultIdentifierExtension,
        debounceCallback: (newVal) => {
            setEdited(true);
            updatePredicateElement({
                ...part,
                dtoState: dtoState.Updated,
                defaultIdentifierExtension: newVal
            });
        }
    });

    if (plainrender) {
        return (
            <PlainRenderElementsWrapper
                overridable={part?.overridable}
                items={[
                    { value: rootValue, placeholderPartial: 'identifier root' },
                    { value: extensionValue, placeholderPartial: 'identifier extension' }
                ]}
            />
        );
    }

    return (
        <>
            <IdentifierContainer>
                <TextField
                    withBorder
                    size={'xs'}
                    id={`part_identifier_root_${id}`}
                    name={`part_identifier_root_${id}`}
                    value={rootValue}
                    onInput={(e) => {
                        setRootValue(e.target.value);
                    }}
                    placeholder={'Enter identifier root'}
                />
            </IdentifierContainer>
            <IdentifierContainer>
                <TextField
                    withBorder
                    size={'xs'}
                    id={`part_identifier_extension_${id}`}
                    name={`part_identifier_extension_${id}`}
                    value={extensionValue}
                    onInput={(e) => {
                        setExtensionValue(e.target.value);
                    }}
                    placeholder={'Enter identifier extension'}
                />
            </IdentifierContainer>
        </>
    );
};

export default IdentifierInput;

IdentifierInput.propTypes = {
    ...ruleEditorViewPartCommonProps
};
